import React, { FC } from 'react'

import { Sticky, StickyContainer as StickyBox } from 'react-sticky'

import { Box } from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
  () =>
    createStyles({
      stickyBlock: {
        marginTop: ({ marginTop }: { marginTop: string }) => marginTop || '85px'
      }
    }),
  { name: 'StickyContainer' }
)

const StickyContainer: FC<any> = ({ height, children, marginTop }) => {
  const classes = useStyles({ marginTop })
  return (
    <StickyBox style={{ height: height || '100%' }}>
      <Sticky topOffset={-85} bottomOffset={85}>
        {({ style, isSticky }) => (
          <Box style={style} className={isSticky ? classes.stickyBlock : ''}>
            {children}
          </Box>
        )}
      </Sticky>
    </StickyBox>
  )
}
export default StickyContainer
